function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
import PropTypes from "prop-types";
import TextFieldGroup, { TextFieldGroupDefaultProps, TextFieldGroupPropTypes } from "../textfieldgroup/TextFieldGroup";
import { Search, Close } from "../../icons";
import { onEnter } from "../../helpers";
const SearchFieldGroup = /*#__PURE__*/React.forwardRef((props, ref) => {
  var _props$value;
  return /*#__PURE__*/React.createElement(TextFieldGroup, _extends({}, props, {
    ref: ref,
    inputProps: {
      icon: true,
      ...props.inputProps
    },
    className: `search-field-group ${props.className}`
  }), /*#__PURE__*/React.createElement("input", null), /*#__PURE__*/React.createElement("i", {
    className: "icon svg-wrapper",
    style: {
      left: 0
    }
  }, /*#__PURE__*/React.createElement(Search, null)), ((_props$value = props.value) === null || _props$value === void 0 ? void 0 : _props$value.length) > 0 && /*#__PURE__*/React.createElement("i", {
    role: "button",
    tabIndex: "0",
    className: "icon link svg-wrapper",
    onKeyPress: onEnter(props.onClear),
    onClick: props.onClear
  }, /*#__PURE__*/React.createElement(Close, {
    className: "close-icon"
  })));
});
SearchFieldGroup.displayName = "SearchFieldGroup";
SearchFieldGroup.defaultProps = TextFieldGroupDefaultProps;
SearchFieldGroup.propTypes = {
  ...TextFieldGroupPropTypes,
  onClear: PropTypes.func.isRequired
};
export default SearchFieldGroup;
//# sourceMappingURL=SearchFieldGroup.js.map